module.exports = __webpack_public_path__ + "img/headphone.043e643e.svg";